

  import fiveStarPageByYear from '@/apollo/queries/5star/fiveStarPageByYear'

  export default {
    data() {
      return {
        pages: {
          type: Array,
          default: () => [],
        },
        productCats: {
          type: Object,
          default: () => {},
        },
        loading: 0,
      };
    },

    head() {
      return {
      title: this.pages[0]?.PageMeta?.Title,
      meta: [
        {
          hid: 'og:title', name: 'og:title', property: 'og:title',
          content: this.pages[0]?.PageMeta?.Title,
        },
        {
          hid: 'og:description', name: 'og:description', property: 'og:description',
          content: this.pages[0]?.PageMeta?.Description,
        },
        {
          hid: 'description', name: 'description',
          content: this.pages[0]?.PageMeta?.Description,
        },
        {
          hid: 'og:image', name: 'og:image', property: 'og:image',
          content: this.pages[0]?.PageMeta?.Image?.url,
        },
      ]
      }
    },

    computed: {
    },
    apollo: {
      $loadingKey: "loading",
      pages: {
        prefetch: true,
        query: fiveStarPageByYear,
        variables() {
          return { currentlocale: this.$normalizeLocale(this.$i18n.locale) , year: this.$route.params.year};
        },
        update(data) {
          if (data && data?.fiveStarPages && data?.fiveStarPages?.data) {
            return this.$normalizeStrapi(data?.fiveStarPages?.data);
          }

          console.debug('*** data err ***')
          return null
        },
        result({ data }) {
        },
      },
    },
  }
